import { useState, useEffect, useRef } from 'react';

export default function SpaceDisclaimer({
  acceptSpaceDisclaimer,
  session,
  showSpaceDisclaimer,
  isMobile,
}) {
  return (
    <>
        <div style={{ position: 'fixed', inset: 0, background: '#080808ee', zIndex: 310, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 24px', fontFamily: 'Georgia, serif', overflowY: 'auto' }}>
          <div style={{ width: '100%', maxWidth: '480px', background: '#07070a', border: '1px solid #272736', borderRadius: '6px', padding: '40px 36px' }}>

            <div style={{ fontSize: '10px', color: '#5a9e8f', letterSpacing: '0.18em', textTransform: 'uppercase', marginBottom: '24px' }}>
              before this shared session
            </div>

            {[
              { heading: 'Your words belong to you', text: 'Everything you say in this session belongs to you. The other participant owns their words. Neither of you may share the other person\'s words outside of Shift without their explicit consent.' },
              { heading: 'How Shift holds this space', text: 'Shift holds context for both participants. It reads both portraits silently to serve the session. It never reveals what it knows about one person to the other. It does not take sides.' },
              { heading: 'The close ritual', text: 'When this session ends, Shift will generate a brief synthesis — what moved, what pattern it noticed, a question to carry forward. This belongs to the session holder. As a participant, you are entitled to your portion on request.' },
              { heading: 'If you delete your account', text: 'If you delete your Shift account after participating in a Shared Space session, your words in existing transcripts will be anonymized — replaced with "Former Participant" — rather than removed. Your personal Shift data is fully deleted. Your words in shared transcripts are anonymized.' },
              { heading: 'What this session is not', text: 'Shared Space is a thinking tool, not mediation, therapy, arbitration, or professional facilitation. Shift is an AI. The session has no legal standing. Do not use it to make binding agreements or replace professional counsel.' },
            ].map((s, i) => (
              <div key={i} style={{ marginBottom: '18px' }}>
                <div style={{ fontSize: '11px', color: '#666', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '6px' }}>{s.heading}</div>
                <div style={{ fontSize: '13px', color: '#444', lineHeight: '1.8' }}>{s.text}</div>
              </div>
            ))}

            <div style={{ fontSize: '11px', color: '#2a2a2a', lineHeight: '1.7', margin: '24px 0 28px' }}>
              By continuing you confirm you have read and understood these terms for shared sessions.
            </div>

            <button onClick={acceptSpaceDisclaimer}
              style={{ width: '100%', background: 'none', border: '1px solid #2a2a2a', borderRadius: '3px', color: '#888', fontSize: '13px', padding: '11px 0', cursor: 'pointer', fontFamily: 'Georgia, serif', letterSpacing: '0.08em' }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = '#444'; e.currentTarget.style.color = '#d4d4d4'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = '#2a2a2a'; e.currentTarget.style.color = '#888'; }}>
              I understand. Continue.
            </button>

          </div>
        </div>
    </>
  );
}
